'use client';

// TODO(DS): replace with @tb/icon when DS icon set is available
import { X } from 'lucide-react';

import { Button, type ButtonProps } from "@/components/ui/button";

/**
 * Shared "Sair" control — a full navigation to the logout route, which clears the session and
 * answers with the redirect home.
 *
 * `window.location.href`, not `router.push`: client-side routing never changes origin, so a
 * session reached through a non-canonical host (an internal port, a preview tunnel) would
 * stay there after "Sair" instead of landing on the real domain.
 *
 * The **route** decides which domain that is, and this is why: `SITE_URL` reads `VERCEL_ENV`,
 * `VERCEL_BRANCH_URL` and `NODE_ENV`, none of which exist in a browser. Read here, in a client
 * component, the deployed bundle fell through to the last branch and sent people to
 * `http://localhost:3000` (reported on 2026-09-25). The origin is decided where it is known.
 *
 * `hideIcon` renders just the "Sair" text (no leading icon) for contexts that use it as a plain
 * text link (e.g. the checkout review greeting row); defaults to `false` so existing callers
 * keep the icon+ghost button look.
 */
export function SignOutButton({
  className,
  hideIcon = false,
  ...props
}: Omit<ButtonProps, "onClick" | "type"> & { hideIcon?: boolean }) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => {
        // The route deletes the cookie and redirects; one navigation, no race between a
        // request and a redirect the browser might win.
        window.location.href = "/api/auth/logout";
      }}
      className={className}
      {...props}
    >
      {hideIcon ? null : <X className="size-[14px]" />} Sair
    </Button>
  );
}
